import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApiService } from './base-api.service';
import { environment } from '../../../environments/environment';
import { BearerToken } from '../models/bearer-token';
import { TotpConfigurationResponse } from '../models/TotpConfigurationResponse';
import { SkipAuthInterceptor } from '../../helpers/http-interceptor-helpers';


@Injectable({
  providedIn: 'root'
})
export class AuthApiService extends BaseApiService<BearerToken> {
      

  public constructor(httpClient: HttpClient) {
    super(httpClient, `${environment.apiUrl}/Authentication`);
  }

  /**
   * Fetch the bearerToken response from the api
   * Requires a previous PWD authenticated request
   */
  public getBearerTokenWithMfaCode(mfaCode: string) {

    var tokenRequest = {
      grant_type: 'mfa',
      scope: '',
      mfa_code: mfaCode,
    }

    let httpParams = new HttpParams();
    httpParams = BaseApiService.populateHttpParams(tokenRequest, httpParams);
    return this.httpClient.post<BearerToken>(`${this.baseApiUrl}/token`, httpParams);
  }

  /**
   * Fetch the bearerToken response from the api
   * On failure, the bearerToken.error_description is populated
   *
   * @param username
   * @param password
  */
  public getBearerToken(username: string, password: string) {

    var tokenRequest = {
      username: username,
      password: password,
      grant_type: 'password',
      scope: '',
    }

    let httpParams = new HttpParams();
    httpParams = BaseApiService.populateHttpParams(tokenRequest, httpParams);
    return this.httpClient.post<BearerToken>(`${this.baseApiUrl}/token`, httpParams, {context: SkipAuthInterceptor()});
  }

  public forgotPassword(username: string) {
    const resetEndpoint = location.href.substring(0, location.href.lastIndexOf('/')) + '/reset-password';

    const request = {
      username,
      resetEndpoint
    };

    return this.httpClient.post(`${this.baseApiUrl}/ForgotPassword`, request);
  }

  public verifyResetToken(resetToken: string) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('resetToken', resetToken);

    return this.httpClient.post(`${this.baseApiUrl}/VerifyResetToken`, null, { params: queryParams });
  }

  public resetPassword(resetToken: string, password: string, ignoreWarnings: boolean) {
    return this.httpClient.post(`${this.baseApiUrl}/ResetPassword`, { resetToken, password, ignoreWarnings });
  }

  public changePassword(currentPassword: string, newPassword: string, ignoreWarnings: boolean) {
    return this.httpClient.post(`${this.baseApiUrl}/ChangePassword`, { currentPassword, newPassword, ignoreWarnings });
  }

  public removeMfa(mfaCode: string) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('mfaCode', mfaCode);
    return this.httpClient.post(`${this.baseApiUrl}/MFA/remove`, null, { params: queryParams });
  }


  public GetMfaConfig(setup: boolean = false) {
    let queryParams = new HttpParams();
    if (setup) queryParams = queryParams.append('setup', setup);

    return this.httpClient.get<TotpConfigurationResponse>(`${this.baseApiUrl}/MFA`, { params: queryParams });
  }

  public enableMfa(mfaCode: string) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('mfaCode', mfaCode);
    return this.httpClient.post(`${this.baseApiUrl}/MFA/setup`, null, { params: queryParams });
  }

  public RefreshToken(refreshToken : string | null) {
    var tokenRequest = {
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
    }

    let httpParams = new HttpParams();
    httpParams = BaseApiService.populateHttpParams(tokenRequest, httpParams);
    return this.httpClient.post<BearerToken>(`${this.baseApiUrl}/token`, httpParams, {context: SkipAuthInterceptor()});
  }
}
